import axios from "axios";
import { silentRequest } from "../authConfig";

const API_URL = process.env.REACT_APP_API_URL;

/**
 * @function RejectSign reject to sign
 * @param {Object} payload {instance, account, id}
 * @returns status
 */
export const RejectSign = (payload) => {
  return payload.instance
    .acquireTokenSilent({ ...silentRequest, account: payload.account })
    .then((tokenResponse) => {
        return axios
        .patch(API_URL + "/documents/reject/" + payload.id, {}, {
          headers: {
            Authorization: "Bearer " + tokenResponse.accessToken,
          },
        }).then((res) => {
          return res.status;
        }).catch((error) => {
          return error;
        })
    })
    .catch((error) => {
      payload.instance.acquireTokenRedirect(silentRequest);
      return error;
    });
};
